<template>
  <div class="dashboard">
    <h1 id="heading">Analytics</h1>
    <va-select
      label="Stores"
      v-model="selectedStores"
      textBy="title"
      multiple
      :options="storeSelectNames"
      v-on:change="updateOrders"
    />

    <div class="date-container">
      <va-date-picker class="date-box" label="Start Date" v-model="startDate" />
      <div class="spacer" />
      <va-date-picker class="date-box" label="End Date" v-model="endDate" />
    </div>
    <va-button id="updateButton" @click="updateOrders()">Update Dashboard</va-button>

    <div class="date-container">
      <va-card class="info-card">
        <template slot="header">
          <h1 class="mt-0 mb-0">Total Orders</h1>
        </template>
        <p class="info-text">{{ orders.length }}</p>
      </va-card>

      <div class="spacer" />

      <va-card class="info-card">
        <template slot="header">
          <h1 class="mt-0 mb-0">Total Value</h1>
        </template>
        <p class="info-text">${{ totalValue }}</p>
      </va-card>

      <div class="spacer" />

      <va-card class="info-card">
        <template slot="header">
          <h1 class="mt-0 mb-0">Average Value</h1>
        </template>
        <p class="info-text">${{ Math.round((totalValue / orders.length) * 100) / 100 }}</p>
      </va-card>
    </div>

    <br />

    <va-card class="graph-container">
      <template slot="header">
        <h1 class="mt-0 mb-0">Number of Orders Over Time</h1>
      </template>
      <div>
        <order-num-chart :chart-data="chartData"></order-num-chart>
      </div>
    </va-card>

    <br />

    <va-card class="graph-container">
      <template slot="header">
        <h1 class="mt-0 mb-0">Value of Orders Over Time</h1>
      </template>
      <div>
        <order-val-chart :chart-data="chartData"></order-val-chart>
      </div>
    </va-card>

    <br />

    <store-summary-table v-bind:orders="orders" v-bind:selectedStores="selectedStores" class="mb-4 graph-container" />
  </div>
</template>

<script>
import OrderNumChart from './charts/orderNumberChart'
import OrderValChart from './charts/orderValueChart'
import StoreSummaryTable from './charts/storeSummaryTable'
const fb = require('./../../firebase/firebaseConfig')

export default {
  name: 'analyticsPage',
  components: {
    OrderNumChart,
    OrderValChart,
    StoreSummaryTable,
  },
  data() {
    return {
      numberofColumns: 3,
      selectedStores: [],
      orders: [
        {
          created: new Date(),
          num_order_items: 0,
          store_id: 0,
          total_order_value: 0,
        },
      ],
      startDate: '',
      endDate: '',
      chartData: {
        labels: [10, 3],
        datasets: [
          {
            label: 'Data One',
            data: [5, 2],
          },
        ],
        orders: [
          {
            created: new Date(),
            num_order_items: 0,
            store_id: 0,
            total_order_value: 0,
          },
        ],
      },
    }
  },
  mounted() {
    const end = new Date()
    const start = new Date()
    start.setDate(start.getDate() - 7)
    this.endDate = `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`
    this.startDate = `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()}`

    this.selectedStores = this.storeSelectNames

    this.updateOrders()
  },
  methods: {
    updateOrders: async function () {
      this.$store.commit('setLoading', true)
      this.orders = []
      const modifiedEndDate = new Date(this.endDate.replace(/-/g, '/'))
      modifiedEndDate.setDate(modifiedEndDate.getDate() + 1) // Add one day so we get all orders from the end date and not just before it
      const endDateString = `${modifiedEndDate.getFullYear()}-${
        modifiedEndDate.getMonth() + 1
      }-${modifiedEndDate.getDate()}`

      for (const store of this.selectedStores) {
        var getOrders = fb.funcs.httpsCallable('getOrderRecordsForStore')
        const storeOrders = (
          await getOrders({
            storeId: store.id,
            startDate: this.startDate,
            endDate: endDateString,
          })
        ).data

        this.orders = this.orders.concat(storeOrders)
      }

      this.orders.forEach((order) => {
        const date = new Date(order.created._seconds * 1000)
        order.created = date
      })

      this.chartData = {
        labels: [10],
        datasets: [
          {
            label: 'Number of Orders',
            data: [5],
          },
        ],
        orders: this.orders,
      }
      this.$store.commit('setLoading', false)
    },
  },
  computed: {
    stores: function () {
      return this.$store.getters.userStores
    },
    storeSelectNames: function () {
      const storeNames = this.$store.getters.userStores.map((store) => {
        return { id: store.id, title: store.title }
      })
      return storeNames
    },
    totalValue: function () {
      let totalVal = 0
      this.orders.map((order) => {
        totalVal += order.total_order_value
      })

      return Math.round(totalVal * 100) / 100
    },
  },
}
</script>

<style lang="scss">
.dashboard {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.date-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  padding-top: 1em;
}

.spacer {
  flex: 1;
}

.date-box {
  flex: 5;
}

.graph-container {
  width: 100%;
}

.info-card {
  flex: 3;
}

.info-text {
  font-size: 50px;
  font-weight: bold;
}

#updateButton {
  width: 50%;
}
</style>
